import { WebLocale } from '@/enums/web-locale';
import { TrackingHelper } from './tracking/tracking-helper';

declare global {
	interface Window {
		tyche: any;
		ramp: any;
	}
}

const IS_DISABLED = true;

export const allowedWebLocales = [WebLocale.au, WebLocale.ca, WebLocale.es, WebLocale.fr, WebLocale.uk, WebLocale.us];

export class VideoAdsHelper {
	private static _isLoaded = false;
	private static _isReadyResolve: (v?: unknown) => void;
	private static _isVideoAdMounted: { value: boolean } = { value: false };

	static isReady = new Promise(resolve => (VideoAdsHelper._isReadyResolve = resolve));
	static videoAdNode: HTMLElement | null = null;
	static alreadyMounted = false;

	/** If the Video Ad is **currently** mounted. */
	static get isVideoAdMounted() {
		return this._isVideoAdMounted.value;
	}

	static get isLoaded() {
		return this._isLoaded;
	}

	static watchMount(cb: (newValue: boolean, oldValue?: boolean) => any) {
		this._isVideoAdMounted = new Proxy(this._isVideoAdMounted, {
			set(self, key: 'value', newValue) {
				if (self[key] != null && newValue !== self[key]) cb(newValue, self[key]);
				self[key] = newValue;

				return true;
			},
		});
	}

	static async displayAds() {
		if (!this.isLoaded) throw new Error('Video Ad not yet loaded. Call VideoAdsHelper.load() first.');
		await this.isReady;

		window.tyche.settings.slots = new Proxy(window.tyche.settings.slots, {
			get(self, key) {
				if (key === 'trendi_video') {
					VideoAdsHelper.videoAdNode = document.getElementById('tyche_trendi_video_container') ?? null;
					VideoAdsHelper._isVideoAdMounted.value = VideoAdsHelper.videoAdNode != null;
				}

				return self[key];
			},
		});

		await window.tyche.addUnits([
			{
				type: 'trendi_video',
			},
		]);

		await window.tyche.displayUnits();
	}

	static load() {
		const c = document.getElementsByTagName('script')[0];
		const tyche = document.createElement('script');
		tyche.type = 'text/javascript';
		tyche.id = 'tyche';
		tyche.src = '//cdn.intergi.com/hera/tyche.js';
		tyche.setAttribute('defer', 'defer');

		window.tyche = {
			mode: 'tyche',
			config: '//config.playwire.com/1024462/v2/websites/73227/banner.json',
			passiveMode: true,
			// callback function for when the API is ready
			onReady: () => this._isReadyResolve(),
		};

		c.parentNode!.insertBefore(tyche, c);

		this._isLoaded = true;
	}

	static shiftVideoAd(isMounted: boolean) {
		if (!isMounted) return;

		const consentBannerVisible = document.querySelector('.consent-banner') != null;
		const mobileBannerVisible = document.querySelector('.mobile-banner.show-banner') != null;

		if (consentBannerVisible && VideoAdsHelper.videoAdNode != null) {
			VideoAdsHelper.videoAdNode.classList.add('jw-no-consent');
		}

		if (mobileBannerVisible && !consentBannerVisible && VideoAdsHelper.videoAdNode != null) {
			VideoAdsHelper.videoAdNode.classList.add('jw-android-banner');
		}
	}

	// function used in component to load video ad
	// weblocale - temporary param to allow restricted rollout
	static loadVideoAd(webLocale: WebLocale) {
		if (!allowedWebLocales.includes(webLocale) || this.isLoaded || IS_DISABLED) return;

		VideoAdsHelper.load();
		VideoAdsHelper.displayAds();

		VideoAdsHelper.watchMount((isMounted: boolean) => {
			VideoAdsHelper.shiftVideoAd(isMounted);

			if (!this.alreadyMounted) {
				const nonInteraction = isMounted ? true : false;
				const action = isMounted ? 'impression' : 'close_clicked';
				TrackingHelper.trackEvent('ad', {
					action,
					label: 'video',
					nonInteraction,
				});
			}

			if (!isMounted) this.alreadyMounted = true;
		});
	}
}
